import type { Lucid } from '../../types/types';

/** Checks if the url starts with a `/` */
const isRelativeUrl = (url: string): url is Lucid.Generic.RelativeURL => url.startsWith('/');

export default isRelativeUrl;
